<template>
  <nav class="account-nav" aria-label="Account navigation">
    <ul>
      <li v-for="item in items" :key="item.to">
        <router-link
          :to="item.to"
          :aria-current="route.path === item.to ? 'page' : undefined"
        >
          {{ item.label }}
        </router-link>
      </li>
      <li>
        <button type="button" :disabled="loggingOut" @click="$emit('logout')">
          {{ loggingOut ? "Signing out…" : "Log out" }}
        </button>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import { accountNavigationItems as items } from "~/core/account/navigation";

defineProps({
  loggingOut: { type: Boolean, default: false },
});
defineEmits(["logout"]);
const route = useRoute();
</script>

<style scoped>
.account-nav ul {
  display: grid;
  gap: 0.25rem;
  margin: 0;
  padding: 0;
  list-style: none;
}
.account-nav a,
.account-nav button {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 44px;
  box-sizing: border-box;
  padding: 0.65rem 0.8rem;
  border: 0;
  border-left: 3px solid transparent;
  background: transparent;
  color: #071c39;
  font: inherit;
  font-weight: 650;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
}
.account-nav a[aria-current="page"] {
  border-left-color: #ee7203;
  background: #fff7ed;
}
.account-nav a:focus-visible,
.account-nav button:focus-visible {
  outline: 3px solid #ee7203;
  outline-offset: 2px;
}
.account-nav button:disabled {
  cursor: wait;
  opacity: 0.65;
}
@media (max-width: 767px) {
  .account-nav ul {
    grid-template-columns: 1fr 1fr;
  }
  .account-nav a,
  .account-nav button {
    border-left: 0;
    border-bottom: 3px solid transparent;
    justify-content: center;
    text-align: center;
  }
  .account-nav a[aria-current="page"] {
    border-bottom-color: #ee7203;
  }
}
</style>
